import { Star } from "lucide-react";
import { Reveal, ChapterHeading } from "./Reveal";
import { TESTIMONIALS } from "@/config";

const Testimonials = () => (
  <section
    id="yorumlar"
    data-testid="testimonials-section"
    className="relative z-10 py-24 sm:py-32 bg-[#0B1325] [&_h2]:text-[#FDFBF7]"
  >
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <ChapterHeading
        chapter={TESTIMONIALS.chapter}
        label={TESTIMONIALS.label}
        title={TESTIMONIALS.title}
      />

      <div className="mt-14 grid md:grid-cols-3 gap-6">
        {TESTIMONIALS.items.map((t, i) => (
          <Reveal key={t.name} delay={i * 0.12} className="h-full">
            <figure
              data-testid={`testimonial-card-${i + 1}`}
              className="card-glow flex h-full flex-col rounded-2xl border border-gold/25 bg-[#111C35]/80 p-7 sm:p-8"
            >
              <span className="font-serif text-6xl leading-none text-gold/40 select-none">“</span>
              <blockquote className="mt-2 flex-1 text-sm sm:text-base text-[#FDFBF7]/85 leading-relaxed">
                {t.quote}
              </blockquote>
              <figcaption className="mt-7 border-t border-gold/20 pt-5">
                <div className="flex gap-1 mb-3">
                  {Array.from({ length: 5 }).map((_, s) => (
                    <Star key={s} className="w-3.5 h-3.5 fill-gold text-gold" />
                  ))}
                </div>
                <div className="font-serif text-lg text-[#FDFBF7]">{t.name}</div>
                <div className="mt-0.5 text-xs font-mono tracking-wider text-[#A8B4CE] uppercase">
                  {t.role}
                </div>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Testimonials;
